import { Dashboard } from "../../../../dashboards/components/Dashboard"
import { PurchaseSection } from "../statistics/PurchaseSection"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"
import { CompanyComingSoonPlaceholder } from "../../../components/CompanyComingSoonPlaceholder"

type Props = Readonly<{}>

export function CompanyReportsHome({}: Props) {
    return (
        <>
            <MatchEnvironment environments={[EnvironmentType.Prod]}>
                <CompanyComingSoonPlaceholder />
            </MatchEnvironment>
            <MatchEnvironment
                environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
            >
                <Dashboard>
                    <PurchaseSection />
                </Dashboard>
            </MatchEnvironment>
        </>
    )
}
